import { useState } from 'react';
import { faqItems } from '@/mocks/home';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">常见问答</h2>
          <p className="mt-2 text-sm text-foreground-500">关于51大赛的常见问题与解答</p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="bg-background-100 rounded-xl border border-background-200/70 overflow-hidden transition-all duration-200"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer hover:bg-background-200/50 transition-colors"
              >
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {item.question}
                </h3>
                <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center">
                  <i
                    className={`ri-arrow-down-s-line text-lg text-foreground-400 transition-transform duration-300 ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                  ></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 ease-in-out overflow-hidden ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}